import React, { useEffect, useMemo, useState } from 'react';
import {
  Box, Chip, InputAdornment, Paper, Table, TableBody, TableCell, TableHead,
  TableRow, TableSortLabel, TextField, Typography
} from '@mui/material';
import { Search, SwapHorizOutlined } from '@mui/icons-material';
import { apiFetch } from '../services/api';

const card={border:'1px solid #e3eaf3',boxShadow:'0 8px 26px rgba(18,46,84,.055)',borderRadius:3,bgcolor:'#fff'};
const fmtDate=v=>{if(!v)return '—';const d=new Date(v);return Number.isNaN(d.getTime())?String(v):d.toLocaleString('pl-PL');};

const powodStyle = powod => {
  const p=String(powod||'PRZENIESIENIE').toUpperCase();
  if(p.includes('MAGAZYN')) return {bg:'#eaf2ff',fg:'#1f5fbf'};
  if(p.includes('PRZEKAZ')) return {bg:'#e7f7ed',fg:'#21833d'};
  if(p.includes('SERWIS') || p.includes('NAPRAW')) return {bg:'#fff1d6',fg:'#a86200'};
  if(p.includes('ZWROT')) return {bg:'#f4efff',fg:'#6d43b7'};
  if(p.includes('WYCOF') || p.includes('LIKWID')) return {bg:'#ffe8e8',fg:'#b3261e'};
  if(p.includes('ZMIANA') || p.includes('PRZENIES')) return {bg:'#eef2f6',fg:'#526173'};
  return {bg:'#f4f6f8',fg:'#475467'};
};

const columns=[
  ['data_przesuniecia','Data'],['numer_unikatowy','Nr unikatowy'],['srodek','Środek trwały'],['numer_inw','Numer INW'],
  ['lokalizacja_z','Z lokalizacji'],['lokalizacja_do','Do lokalizacji'],['uzytkownik_z','Użytkownik z'],['uzytkownik_do','Użytkownik do'],
  ['powod','Powód'],['komentarz','Notatka / uzasadnienie'],['wykonal_nazwa','Przesunięcie wykonał']
];

export default function Przesuniecia(){
  const[dane,setDane]=useState([]); const[szukaj,setSzukaj]=useState('');
  const[sort,setSort]=useState('data_przesuniecia'); const[order,setOrder]=useState('desc');
  useEffect(()=>{apiFetch('/przesuniecia').then(setDane);},[]);

  const widoczne=useMemo(()=>{
    const q=szukaj.trim().toLowerCase();
    const arr=dane.filter(x=>!q || [x.numer_unikatowy,x.numer_inw,x.numer_seryjny,x.srodek,x.lokalizacja_z,x.lokalizacja_do,x.uzytkownik_z,x.uzytkownik_do,x.wykonal_nazwa,x.powod,x.komentarz].some(v=>String(v||'').toLowerCase().includes(q)));
    return [...arr].sort((a,b)=>{
      let av=a[sort],bv=b[sort];
      if(sort==='data_przesuniecia'){av=new Date(av||0).getTime();bv=new Date(bv||0).getTime();}
      else {av=String(av||'').toLocaleLowerCase('pl');bv=String(bv||'').toLocaleLowerCase('pl');}
      const cmp=typeof av==='number' ? av-bv : av.localeCompare(bv,'pl',{numeric:true,sensitivity:'base'});
      return order==='asc'?cmp:-cmp;
    });
  },[dane,szukaj,sort,order]);

  const changeSort=field=>{if(sort===field)setOrder(o=>o==='asc'?'desc':'asc');else{setSort(field);setOrder('asc');}};

  return <Box>
    <Box sx={{mb:2.5}}><Typography variant="h4" fontWeight={900}>Historia przesunięć</Typography><Typography color="text.secondary">Historia zmian lokalizacji i przypisania.</Typography></Box>
    <Paper sx={{...card,overflow:'hidden'}}>
      <Box sx={{p:2,borderBottom:'1px solid #edf1f6',bgcolor:'#fbfdff'}}><TextField size="small" fullWidth value={szukaj} onChange={e=>setSzukaj(e.target.value)} placeholder="Szukaj po środku, numerze INW, użytkowniku, lokalizacji, powodzie lub notatce..." InputProps={{startAdornment:<InputAdornment position="start"><Search fontSize="small"/></InputAdornment>}}/></Box>
      <Box sx={{overflowX:'auto'}}><Table size="small" sx={{minWidth:1550}}><TableHead><TableRow sx={{bgcolor:'#f8fafc'}}>
        {columns.map(([f,h])=><TableCell key={f} sx={{fontWeight:850,color:'#344054',whiteSpace:'nowrap'}}><TableSortLabel active={sort===f} direction={sort===f?order:'asc'} onClick={()=>changeSort(f)}>{h}</TableSortLabel></TableCell>)}
      </TableRow></TableHead><TableBody>
        {widoczne.map(x=>{const ps=powodStyle(x.powod);return <TableRow key={x.id_przesuniecia} hover sx={{'& td':{borderColor:'#edf1f6',verticalAlign:'top'}}}>
          <TableCell sx={{whiteSpace:'nowrap'}}>{fmtDate(x.data_przesuniecia)}</TableCell>
          <TableCell><Chip size="small" label={x.numer_unikatowy||'—'} sx={{bgcolor:'#eaf2ff',color:'#1f5fbf',fontWeight:900}}/></TableCell>
          <TableCell sx={{minWidth:220}}><Typography variant="body2" fontWeight={800}>{x.srodek||'—'}</Typography>{x.numer_seryjny&&<Typography variant="caption" color="text.secondary">SN: {x.numer_seryjny}</Typography>}</TableCell>
          <TableCell sx={{fontWeight:750}}>{x.numer_inw||'—'}</TableCell><TableCell>{x.lokalizacja_z||'—'}</TableCell>
          <TableCell><Box sx={{display:'flex',alignItems:'center',gap:.5}}><SwapHorizOutlined fontSize="small" color="primary"/><Typography variant="body2" fontWeight={750}>{x.lokalizacja_do||'—'}</Typography></Box></TableCell>
          <TableCell>{x.uzytkownik_z||'—'}</TableCell><TableCell sx={{fontWeight:700}}>{x.uzytkownik_do||'—'}</TableCell>
          <TableCell><Chip size="small" label={x.powod||'PRZENIESIENIE'} sx={{bgcolor:ps.bg,color:ps.fg,fontWeight:850}}/></TableCell>
          <TableCell sx={{minWidth:240}}>{x.komentarz?<Box sx={{p:1,bgcolor:'#f8fafc',borderRadius:1.5,whiteSpace:'pre-wrap'}}>{x.komentarz}</Box>:<Typography variant="body2" color="text.secondary">Brak notatki</Typography>}</TableCell>
          <TableCell sx={{minWidth:150}}><Typography variant="body2" fontWeight={750}>{x.wykonal_nazwa||'—'}</Typography></TableCell>
        </TableRow>})}
        {!widoczne.length&&<TableRow><TableCell colSpan={11} align="center" sx={{py:5,color:'text.secondary'}}>Brak przesunięć pasujących do wyszukiwania.</TableCell></TableRow>}
      </TableBody></Table></Box>
      <Box sx={{px:2,py:1.4,borderTop:'1px solid #edf1f6'}}><Typography variant="caption" color="text.secondary">Wyświetlono {widoczne.length} z {dane.length} zapisanych przesunięć. Kliknij nagłówek kolumny, aby sortować.</Typography></Box>
    </Paper>
  </Box>;
}
